function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.4005 40.6629L29.0938 4.61459C27.3623 1.46632 22.6398 1.46632 20.9081 4.61459L0.601524 40.6629C-1.13 43.8111 1.07381 47.7466 4.69437 47.7466H45.1503C48.9282 47.5892 51.132 43.8111 49.4005 40.6629Z",
  fill: "#E24C4B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0009 6.9758L45.3076 43.0241H4.69434L25.0009 6.9758Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6955 23.5046L22.9549 31.8476C23.1123 32.7921 23.8993 33.5792 25.0013 33.5792C25.9458 33.5792 26.8903 32.7921 27.0477 31.8476L28.3071 23.5046C28.6219 21.4581 27.0477 19.7266 25.0013 19.7266C22.9548 19.7265 21.538 21.4581 21.6955 23.5046Z",
  fill: "#E24C4B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0011 39.0888C26.0444 39.0888 26.8901 38.243 26.8901 37.1997C26.8901 36.1564 26.0444 35.3107 25.0011 35.3107C23.9578 35.3107 23.1121 36.1564 23.1121 37.1997C23.1121 38.243 23.9578 39.0888 25.0011 39.0888Z",
  fill: "#E24C4B"
});

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.08cfadf6.svg";
export { ForwardRef as ReactComponent };